/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: 'Revizuire AI',
    AIReviewFailed: 'Examinarea AI a eșuat',
    AIReviewPassed: 'Revizuirea AI a trecut',
    AIReviewStatus: 'Starea revizuirii AI',
    AIReviewing: 'Revizuirea AI este în curs de revizuire',
    America: {},
    CheckSupportInstall: 'Verificați dacă este susținută modernizarea',
    ImporterCommunityDisplayName: 'Nume afișat al comunității importatorului',
    ImporterContactEmail: 'E-mail de contact al importatorului',
    IndicatorLight: 'Indicator lumină',
    Instruction: 'Înștiințare',
    MostPicture4OrVideo: '(Maxim 4 fotografii / 1 video)',
    PleaseContactPersonnelCommunicating: 'Vă rugăm să contactați personalul CFMOTO pentru comunicare',
    Redemptionservice: 'Serviciu valorificat',
    USD: {},
    UnbindingApplicationCommitment: {},
    aboutAccount: 'Despre cont',
    aboutVehicle: 'Despre vehicul',
    accountApplyRejected: 'Cerere de ștergere a contului respinsă',
    accountCancel: 'Cerere de ștergere a contului',
    accountDeletExplain: 'Ghid de ștergere a contului',
    accountDelete: 'Ștergeți contul',
    accountDeleted: 'Cont șters',
    accountFormatError: 'Format de cont incorect/utilizatorul nu există. Vă rugăm să potriviți copywriting-ul corespunzător în funcție de cauza reală',
    accountNumber: 'Număr de cont',
    action: 'Operațiune',
    actionFail: 'operațiunea eșuată',
    actionSuccess: 'Operațiune reușită',
    activeScore: 'Scor activ',
    activeTrigger: 'Utilizatorii declanșează în mod activ (Despre APP—Accesați evaluarea)',
    activity: 'Activitate',
    activityCancel: 'Anularea evenimentului',
    activityCover: 'Coperta evenimentului',
    activityDetails: 'Detalii eveniment',
    activityId: 'ID activitate',
    activityList: 'Lista activităților',
    activityManagement: 'Management de evenimente',
    activitySearch: 'Căutare activă',
    activityTime: 'Ora evenimentului',
    activityTitle: 'Titlul evenimentului',
    activityVenue: 'Locația evenimentului',
    adaptable: 'Pentru',
    add: 'Adăugați',
    addAccountDeletExplain: 'Adăugați notificare de ștergere a contului',
    addAuthenticationTime: 'Timp adăugare autentificare',
    addCanadaPrivacyPolicy: 'Adăugați Politica de confidențialitate Canada',
    addCanadaTelematicsPolicy: 'Adăugați acordul telematic din Canada',
    addCanadaUserPolicy: 'Adăugați un acord de utilizare canadian',
    addDashcamHelp: 'Asistență Cameră de Bord Adăugată',
    addDataDeletExplain: 'Adăugare notificare de ștergere a datelor',
    addEmail: 'Email nou',
    addExhibitionCategory: {},
    addExhibitionSeries: {},
    addHelpConfiguration: 'Adăugarea instrucțiunilor de ajutor pentru configurare',
    addInformationCategory: 'Adăugați o nouă categorie de informații',
    addInformationContent: 'Adăugați conținut de informații noi',
    addKolUserAuthentication: 'Adăugare autentificare utilizator KOL',
    addPicture: 'Adăugați o imagine',
    addPrivacyAgreement: 'Adăugați acord de confidențialitate',
    addPrivacySubmitSure: 'Data intrării în vigoare și descrierea modificării noii politici de confidențialitate nu pot fi ajustate după trimitere. Confirmați trimiterea.',
    addPushConfiguration: 'Adăugați configurația push',
    addQuestion: {},
    addSdkStaement: 'Adăugați declarația SDK',
    addServiceIntroduce: 'Introducere în noile servicii',
    addShowroomModel: 'Adaugă modele de showroom',
    addThisUser: 'Adăugați acest utilizator',
    addTopic: 'Adăugați o temă',
    addUser: 'Adăugați utilizatori',
    addUserAgreement: 'Adăugați acordul utilizatorului',
    addUserRole: 'Adăugați rol de utilizator',
    addVehicleModel: 'Modele noi',
    addVehicleModelCategory: 'Categoria de vehicule noi',
    addVideo: 'Adăugați un videoclip',
    addedBy: 'Adăugat de',
    additionalFeedback: 'Feedback suplimentar',
    administratorUnbind: 'Deconectarea administratorului',
    afternoon: 'După amiază',
    agreeServiceAgreement: 'Prin activarea serviciului, sunteți de acord cu Acordul de Servicii',
    agreeSignOut: 'A acceptat să înceteze',
    agreementContent: 'Acord',
    all: 'Toate',
    allArea: 'Țara/regiunea țintă',
    allComment: 'Toate comentariile',
    allImportSuccess: 'Import finalizat. Toate au fost importate cu succes',
    allServicesSimultaneously: 'Toate serviciile',
    allUser: 'Toți utilizatorii',
    allVehicleModel: 'Toate modelele',
    alreadyOver: 'Toate aici',
    ambientLightControl: 'Control iluminare ambientală',
    amount: 'Sumă',
    android: 'Android',
    answer: {},
    answerOta1: 'OTA înseamnă că vehiculul descarcă cel mai recent software firmware din cloud prin rețeaua celulară și puteți actualiza vehiculul online prin CFMOTO RIDE pentru a optimiza continuu experiența de călătorie',
    answerOta2: 'Când o nouă versiune a ecranului tft care poate fi actualizată, veți primi notificarea de actualizare. Dacă %s este afișat în partea de jos a paginii curente, înseamnă că afișajul tft al vehiculului nu trebuie să fie actualizat.',
    answerOta3: 'Puteți da clic pe %s în colțul din dreapta sus pentru a afla mai multe instrucțiuni de operare OTA în avans',
    anyCar: 'Ai mașină?',
    appMessagePushCountLimit: 'Ai atins limita de notificări push pentru această lună (2 ori/lună). Conținutul editat poate fi salvat ca schiță. Vrei să îl salvezi?',
    appPush: 'Notificare push în aplicație',
    appRating: 'Managementul mecanismului de notare',
    appType: 'Sistem telefonic',
    appVersion: 'Versiunea APP',
    applicableCountry: {},
    applicableCountryName: {},
    applyTime: 'Timp de aplicare',
    applyUnbinding: 'Aplicarea dezlegării',
    appointmentReleaseTime: 'Ora de eliberare a programării',
    approval: 'Aprobare',
    arrivalNumberDescription: 'Numărul de dispozitive care au primit notificarea',
    arrivalNumberDescription0: 'Numărul efectiv de sosiri la terminalul dispozitivului după este trimis mesajului de notificare (sosirile după 5 zile nu vor fi luate în considerare)',
    arrivalNumberVolume: 'Numărul de sosiri',
    askAllowUserSpeakInCommunity: 'Permiteți unui utilizator blocat să posteze în comunitate',
    askApproveIt: 'Îl aprobați',
    askDeleteCategory: {},
    askDeleteInformactionCategory: 'Dacă să ștergeți această categorie de informații',
    askDeleteInformationContent: 'Dacă să ștergeți conținutul de informații',
    askDeleteKolUserAuthentication: 'Ești sigur că vrei să ștergi această autentificare a utilizatorului KOL?',
    askDeleteOfficialAuth: 'Ești sigur că vrei să ștergi autentificarea oficială pentru acest cont?',
    askDeleteQuestion: {},
    askDeleteThisActivity: 'Ștergeți această activitate',
    askDeleteThisBanner: 'Ștergeți acest Banner',
    askDeleteThisComment: 'Sunteți sigur că doriți să ștergeți acest comentariu',
    askDeleteThisPost: 'Ștergeți această postare',
    askDeleteThisTopic: 'Ștergeți acest subiect',
    askDeleteVehicleType: 'Sunteți sigur că veți șterge modelul vehiculului',
    askDeleteVehicleTypeCategory: 'Dacă să ștergeți această categorie de model',
    askDeleteVehicleTypeDetails: 'Dacă să ștergeți detaliile modelului de mașină',
    askDeleteVehicleTypeSeries: 'Dacă să ștergeți această serie de modele',
    askLogout: 'Sunteți sigur că vreți să ieșiți din sistem?',
    askNotApproveIt: 'Nu-l aprobați',
    askSaveSettings: 'Setările nu au fost încă salvate, doriți să le salvați?',
    associatedPostNumber: 'Numărul de postări conexe',
    associatedPosts: 'Articole pe aceeași temă',
    associatedVehicle: 'vehicul asociat',
    assoclatedContent: 'Conținut asociat',
    atmosphereCContent: 'Setările nu au fost încă salvate, doriți să le salvați?',
    atmosphereContent1Msg1: 'După ce funcția este activată, telefonul mobil pornește Bluetooth și aplicația continuă să ruleze. Când vă apropiați de vehicul de departe până aproape, vehiculul poate fi deblocat și pornit automat.',
    atmosphereContent1Msg2: 'Dacă în mod normal nu este deblocat și pornit, apăsați butonul de alimentare al vehiculului pentru a debloca și porni',
    atmosphereContent1Msg3: 'Deblocarea automată de proximitate va fi declanșată o singură dată înainte de deconectarea Bluetooth',
    atmosphereContent2Msg1: 'După ce funcția este activată, vehiculul se va opri automat după 5 secunde după oprirea celor trei condiții ale vehiculului, viteza vehiculului este 0 și templul este abandonat',
    atmosphereContent2Msg2: 'Pornirea vehiculului în timpul perioadei de oprire automată, viteza vehiculului nu este 0 sau templul este pus deoparte va anula oprirea automată',
    atmosphereContent3Msg1:
      'După ce funcția este pornită, când vehiculul este oprit, telefonul mobil pornește Bluetooth și aplicația continuă să funcționeze sau poartă cheia fizică. Când vă apropiați de vehicul de departe până aproape, luminile vehiculului vor clipi pentru a întâmpina oaspeții',
    atmosphereContent3Msg2: 'Pentru a preveni declanșatoarele frecvente să provoace pierderi de putere ale vehiculului, după ce funcția de întâmpinare este declanșată de două ori în decurs de 30 de secunde, aceasta nu se va relua decât după 30 de minute',
    atmosphereContent4Msg1: 'După ce funcția este activată, luminile pentru faza lungă și scurtă vor fi aprinse automat timp de 10 secunde după ce vehiculul este oprit',
    atmosphereIntroduce1: 'Aproape de instrucțiuni de deblocare automată',
    atmosphereIntroduce2: 'instrucțiuni de oprire automată',
    atmosphereIntroduce3: 'Instrucțiuni de trezire automată',
    atmosphereIntroduce4: 'Luminile stinse cu întârziere',
    atmosphereSetINfo: 'Noile setări vor intra în vigoare în 1-3 minute de la pornirea vehiculului, vă rugăm să vă asigurați că vehiculul este într-o poziție bună a semnalului',
    auditStatus: 'Stare revizuire',
    authType: 'Tip de autentificare',
    authenticatedName: 'Nume autentificat',
    avatar: 'Avatar',
    backApply: 'formular de retragere',
    backApplySuccess: 'retragerea cererii cu succes',
    backHome: 'Înapoi la pagina principală',
    bannerDisplayImages: 'Poza banner',
    bannerList: 'Lista de bannere',
    bannerManagement: 'Gestionarea anunțurilor banner',
    bannerPictrure: 'Desen banner',
    bannerSearch: 'Căutare bannere',
    bannerTitle: 'Titlu banner',
    baseService: 'Standard Edition\n',
    baseServicePay: 'Plată pentru Standard Edition',
    baseServiceResetTimeRule: 'Ora de resetare a serviciului de bază nu poate fi ulterioară timpului curent',
    batchImport: 'Import lot',
    batchUser: 'Utilizatori de loturi',
    beijingTime: 'Ora UTC+8',
    belogCategory: 'categorie',
    belongCategory: {},
    bindDevice: 'Dispozitiv de legare',
    bindEmail: 'Legă email',
    bindVehicle: 'Legați vehiculul',
    bindingStatus: 'Stare conectare',
    bindingText1: '1.\tServicii telematice',
    bindingText10: '1.1.2.\tFurnizarea de planificare a rutei în timpul navigării, inclusiv calcularea distanței dintre vehicule și navigarea pe jos în scopul găsirii unui vehicul .',
    bindingText11: '1.2.\tTrimiterea notificărilor necesare către Client în funcție de condițiile vehiculului.',
    bindingText12:
      '1.2.1.\tCFMOTO va încheia notificările Clientului privind întreținerea vehiculului (de exemplu, în funcție de distanța totală pe care o parcurge Clientul, momentul la care Clientul cumpără vehiculul, cerințele de timp sau distanță de condus pentru întreținerea vehiculului) .',
    bindingText13:
      '1.2.2.\tPe baza datelor vehiculului , CFMOTO va trimite Clientului notificări privind situația anormală; inclusiv analiza datelor de către OEM (în funcție de model) pentru a oferi asistență clienților și optimizarea ulterioară a vehiculului .',
    bindingText14: '1.3.\tAsistență în analiza cauzei accidentului în cazul în care Clientul raportează un accident grav al Autovehiculului.',
    bindingText15:
      '1.3.1.\tÎn cazul unui accident grav al Vehiculului, cum ar fi atunci când Vehiculul se răstoarnă sau se răstoarnă pe o parte în timpul conducerii, CFMOTO va sprijini Clientul la cerere în a clarifica dacă accidentul se datorează unei defecțiuni a Vehiculului sau altor circumstanțe. Solicitarea urmează să fie înaintată către CFMOTO de către Client prin intermediul distribuitorului/partenerului de vânzări local indicat în Contractul de vânzare a vehiculelor.',
    bindingText16: '1.3.2.\tÎn măsura în care datele disponibile permit acest lucru, CFMOTO va evalua datele în raport cu cauza accidentului și va furniza Clientului un raport corespunzător.',
    bindingText17: '1.4.\tAsistență pentru Client pentru recuperarea Vehiculului după pierderea Vehiculului .',
    bindingText18:
      '1.4.1.\tDacă Vehiculul este pierdut, CFMOTO va furniza Clientului datele de locație ale Vehiculului și alte date utile de stare a Vehiculului (cum ar fi locația ultimei activări, starea curentă a vehiculului etc.) la cerere și dacă sunt disponibile.',
    bindingText19: '1.4.2.\tSolicitarea urmează să fie înaintată către CFMOTO de către Client prin intermediul distribuitorului/partenerului de vânzări local indicat în Contractul de vânzare a vehiculelor.',
    bindingText2:
      'CFMOTO Powersports, Inc. (denumită în continuare „ CFMOTO ” ) oferă servicii de telematică pentru vehicule clientului care a cumpărat vehiculul CFMOTO (denumit în continuare „Client” ). Pentru aceste servicii, CFMOTO folosește datele înregistrate de Vehicul despre Vehicul și comportamentul său de conducere în perioada de timp relevantă. În detaliu, aceasta se referă la următoarele date:',
    bindingText20: '1.5.\tRaportarea problemelor post-vânzare .',
    bindingText21: '1.5.1.\tCFMOTO colectează de la distanță notificări cu coduri de eroare trimise de Vehicul în cazul unei defecțiuni a componentelor sale și furnizează informațiile respective la cererea Clientului direct Clientului.',
    bindingText22: '1.5.2.\tSolicitarea urmează să fie înaintată către CFMOTO de către Client prin intermediul distribuitorului/partenerului de vânzări local indicat în Contractul de vânzare a vehiculelor.',
    bindingText23: '2.\tRestricții și excluderi ale serviciului',
    bindingText24:
      '2.1.\tSe subliniază în mod expres că modificările structurale sau alte modificări tehnice ale Vehiculului pot limita furnizarea serviciilor sau chiar o pot face imposibilă, deoarece serviciile depind de furnizarea corectă a datelor vehiculului.',
    bindingText25: '2.2.\tÎn cazul în care astfel de servicii nu pot fi furnizate din cauza performanței oricăror rețele de date sau de telecomunicații terță parte , orice răspundere a CFMOTO este exclusă.',
    bindingText26: '3.\tConfidențialitate',
    bindingText27:
      'CFMOTO va respecta reglementările aplicabile privind protecția datelor atunci când prelucrează datele cu caracter personal în legătură cu vehiculul CFMOTO . Termenii politicii de confidențialitate a CFMOTO sunt stabiliți în această aplicație CFMOTO RIDE . Ca un supliment la politica de confidențialitate , această notificare respectă politica de confidențialitate . Și Clientul se poate referi la politica de confidențialitate pentru unele conținuturi legate de prelucrarea datelor care nu sunt acoperite de această notificare.',
    bindingText28: '4.\tServiciu clienți',
    bindingText29:
      '4.1.\tClientul se poate simți liber să trimită întrebări, comentarii sau preocupări legate de confidențialitate la CFMOTORIDEAPP@cfmotousa.com sau să scrie la: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Clientul poate, de asemenea, suna Relații cu clienții CFMOTO la (888) 823-6686. ',
    bindingText3: 'Date despre comportamentul de condus al utilizatorului : inclusiv accelerația, decelerația, viteza, îndoirea, ultimul timp de condus și ultimul kilometraj de condus .',
    bindingText30: '5.\tRevizii _',
    bindingText31: '5.1.\tCFMOTO își rezervă dreptul de a modifica această notificare în orice moment, dar vom publica revizuiri pe CFMOTO RIDE Aplicați și/sau furnizați o notificare înainte de a face acest lucru, după caz.',
    bindingText4:
      'Date despre starea vehiculului: se referă la starea în timp real a vehiculului, inclusiv modul de conducere, combustibil rezidual, economia instantanee de combustibil, kilometrajul, viteza de viteză în timp real a vehiculului, turația motorului, presiunea anvelopelor, temperatura anvelopelor, datele privind tensiunea de activare a bateriei , temperatura lichidului de răcire, starea blocării electronice, versiunea software a dispozitivului inteligent, puterea semnalului dispozitivelor inteligente, setarea curentă a tabloului de bord.',
    bindingText5:
      'Date de alarmă vehicul: date de alarmă care trebuie trimise dacă anumite date depășesc o valoare prestabilită, cum ar fi temperatura motorului, viteza excesivă, timpul excesiv de condus, temperatura ridicată a lichidului de răcire, mișcarea anormală a vehiculului, presiunea anormală a anvelopelor, vibrațiile, descărcarea, coliziunea etc. .',
    bindingText6: 'Informații de eroare vehicul: se referă la codurile de eroare raportate de fiecare parte internă a vehiculului.',
    bindingText7: 'Date despre locația vehiculului: se referă la locația geografică specifică a vehiculului.',
    bindingText8: '1.1.\tFurnizarea ing Clientul cu servicii legate de vehicul prin APLICIA CFMOTO RIDE ',
    bindingText9:
      '1.1.1.\tConsumatorii pot gestiona vehiculele de la distanță prin intermediul aplicației CFMOTO RIDE (inclusiv vizualizarea locației vehiculului, setarea informațiilor și funcțiilor vehiculului, controlul de la distanță a stării vehiculului etc.).',
    bindingUser: 'Asociază utilizator',
    bothServices: 'Ambele servicii',
    bound: 'Conectat',
    businessType: 'Tipul afacerii',
    button: 'Buton',
    callbackedApply: 'V-ați retras cererea de ștergere a contului pe yyyy-MM-dd HH:mm:ss',
    callbackedApplySyncTip:
      'Cererea de ștergere a datelor dvs. a fost trimisă la yyyy-MM-dd HH:mm:ss. Contul dvs. și datele aferente vor fi șterse definitiv la 15 zile după ce primim cererea dvs. După ștergere, nu veți mai putea utiliza serviciul CFMOTO RIDESYNC. Pentru a anula ștergerea contului, vă rugăm să revedeți pagina web sau să vă conectați la APP în termen de 15 zile pentru a retrage solicitarea de ștergere a contului.',
    callbackedApplyTip:
      'Cererea de ștergere a datelor dvs. a fost trimisă la yyyy-MM-dd HH:mm:ss. Contul dvs. și datele aferente vor fi șterse definitiv la 15 zile după ce primim cererea dvs. După ștergere, nu veți mai putea utiliza serviciul CFMOTO RIDE. Pentru a anula ștergerea contului, vă rugăm să revedeți pagina web sau să vă conectați la APP în termen de 15 zile pentru a retrage solicitarea de ștergere a contului.',
    canadaPrivacyPolicy: 'Politica de confidențialitate Canada',
    canadaTelematicsPolicy: 'Acordul Canada Telematics',
    canadaUserPolicy: 'Acord de utilizare canadian',
    canadianAgreementText: 'Textul acordului canadian',
    cancel: 'Anulează',
    cancellationAgreement: 'Acord de anulare',
    cancelled: 'Anulat',
    carOwner: 'Proprietar',
    carUserScore: 'Evaluările proprietarului vehiculului',
    cardPass: 'Verificarea identității a avut succes!',
    cfmotoName: 'CFMOTO',
    changeCodeValidate: 'Treceți la verificarea Captcha',
    changeDescriptionType: 'modifică descrierea',
    changeDescriptionTypeSelectNo: 'Nu implică modificări ale reglementărilor privind prelucrarea informațiilor personale',
    changeDescriptionTypeSelectYes: 'Modificări ale reglementărilor care implică prelucrarea informațiilor personale',
    changeEmail: 'Modifică email',
    changeEmailInfo: 'Comutați la e-mail',
    changeFail: 'Modificarea stării a eșuat',
    changeOne: 'Schimbare',
    changePassValidate: 'Treceți la Verificare prin parolă',
    changePasswordFailed: 'Schimbarea parolei a eșuat',
    changePasswordSuccessful: 'Schimbarea parolei cu succes',
    changePhoneInfo: 'Comutați la numărul de telefon',
    changeStore: 'Modificare magazin',
    changeSuccess: 'Starea a fost modificată cu succes',
    channelType: 'canal de feedback',
    characterLimitExceeded: 'Limita de caractere depășită',
    checkConfigurationTwo: 'Chineză sau engleză %s nu este complet configurată, vă rugăm să verificați',
    checkCopyWriting: 'Conținutul în chineză sau engleză nu este completat, vă rugăm să verificați',
    checkEmpty: '%s este gol, vă rugăm să verificați',
    checkEmptyEnglish: 'Engleza este incompletă. Te rugăm să verifici',
    checkTriggerType: 'Există o condiție a mecanismului de declanșare care nu a fost completată, vă rugăm să verificați',
    checkUpdate: 'Verificați actualizările',
    cityFilter: 'Filtru oraș',
    clickImmediateFeedback: 'Faceți clic pentru a oferi feedback acum',
    clickNumber: 'Numărul de clicuri',
    clickNumberDescription: 'Numărul de notificări pe care utilizatorii au dat click',
    clickNumberVolume: 'Numărul de clicuri',
    clickToFeedback: 'Faceți clic pentru feedback',
    clicks: 'Clic',
    closeNum: 'închidere',
    closeTask: 'Sarcina anulată',
    code: 'Cod de verificare',
    colorPicture: 'Imagine bloc color',
    comment: 'Comentariu',
    commentContent: 'Comentarii',
    commentList: 'Lista recenziilor',
    commentNumber: 'Numărul de comentarii',
    commentTime: 'Timpul comentariilor',
    communication: 'în comunicare',
    community: 'Comunitate',
    communityManagement: 'Managementul comunității',
    communityRule: 'Norme comunitare',
    completePuzzle: 'Vă rugăm să completați puzzle-ul',
    completed: 'efectuat',
    condition: 'condiție',
    configureLanguage: 'Configurați limba',
    configurePicture: 'Configurați imaginea',
    confirm: 'Confirmă',
    confirmDeletePictures: 'Confirmați pentru a șterge această imagine',
    confirmRedeem: 'Confirmați valorificarea',
    confirmReviewNoPass: 'Confirmați pentru a nu trece revizuirea',
    confirmReviewPass: 'Confirmați pentru a trece revizuirea',
    consultDealer: 'Vă rugăm să consultați distribuitorul local',
    contact: 'Solicitarea dvs. de ștergere a contului a fost respinsă. Dacă aveți întrebări, vă rugăm să contactați it@cfmoto.com pentru consultare.',
    contactMail: 'Adresa de e-mail',
    contactMethod: 'Contactor',
    contactUs: 'Contactați-ne',
    content: 'Conținut',
    contentType: 'Tip de conținut',
    copyFail: 'Copierea eșuată',
    copyLink: 'Copiază legătură',
    copySuccess: 'Copiat cu succes',
    copyWriting: 'Conținut pop-up',
    country: 'Țară/Regiune',
    countryCode: 'Codul tarii',
    countryName: 'Țară',
    countryNumber: 'Codul țării',
    countryRegion: 'Țara/Regiune',
    create: 'Adăugare nouă',
    createBy: 'Creator',
    createStore: 'Creare magazin',
    createTime: 'timpul de creație',
    cs_CZ: 'ceh',
    currency: 'Monedă',
    currentConfig: {},
    currentCountryStoreTotal: 'Numărul total de magazine din țara curentă',
    currentRedemptionRatio: 'Rată actuală de conversie',
    currentTime: 'Ora curentă',
    customPage: 'Pagină personalizată',
    customSettings: 'Coloane personalizate',
    dashcamHelp: 'Asistență Cameră de Bord',
    dataDeletExplain: 'Ghid de ștergere a datelor',
    dataDelete: 'Ștergeți datele',
    dataDeleteApply: 'Cerere de ștergere a datelor',
    dataFormatError: 'Eroare de format de date',
    dataPermissionScope: 'Domeniul de aplicare a permisiunii de date',
    dataType: 'Tip de date',
    dayOne: 'zile o dată',
    days: 'zi',
    daysAgo: '%s zile în urmă',
    de_DE: 'limba germana',
    dealDate: 'Timp de procesare',
    dealerOperationList: 'Lista operațiunilor distribuitorului',
    dealerOperationQuery: 'Interogare operațiuni distribuitor',
    dealerOperationRecord: 'Înregistrare operațiuni dealer',
    dealerStore: 'Magazinele dealerului',
    dealerStoreImportTempateName: 'Șablon de import pentru magazinele dealerilor',
    dealerStoreQuery: 'Interogarea magazinelor dealerului',
    dealers: 'Importator',
    default: 'Mod implicit',
    defaultMap: 'Hartă implicită',
    delete: 'Ștergeți',
    deleteAccountSYNCStep: 'Puteți solicita ștergerea contului dumneavoastră CFMOTO RIDESYNC urmând următorii pași',
    deleteAccountStep: 'Puteți solicita ștergerea contului dumneavoastră CFMOTO RIDE urmând următorii pași',
    deleteDataSYNCStep: 'Puteți solicita ștergerea datelor dvs. din contul CFMOTO RIDESYNC urmând acești pași',
    deleteDataStep: 'Puteți solicita ștergerea datelor dvs. din contul CFMOTO RIDE urmând acești pași',
    deleteFail: 'Ștergerea a eșuat',
    deleteFinish: 'Ștergerea sa încheiat',
    deleteKolUserAuthentication: 'Ștergere autentificare utilizator KOL',
    deleteStore: 'Ștergere magazin',
    deleteSuccess: 'Ștergere reușită',
    deleteTip: 'Sigur vrei să ștergi această postare? Odată șterse, informațiile nu pot fi recuperate',
    deleteVersionWarn: 'Dacă să ștergeți această înregistrare a versiunii',
    deleteVideo: 'Ștergeți acest videoclip?',
    detailAddress: 'Adresa detaliată',
    details: 'Detalii',
    determine: 'Sigur',
    deviceCodeGet: 'Obțineți codul dispozitivului:',
    deviceContent:
      'Codul echipamentului receptorului electronic de gard (denumit: cheie) este un șir de coduri din 10 cifre. Codul echipamentului, codul QR și marcajul CE sunt imprimate pe autocolantul autoadeziv din PVC argintiu. Există trei etichete în total, una a fost aplicată pe caroseria vehiculului (trebuie să ridicați perna scaunului pentru a vedea); celelalte două sunt introduse în geanta pentru accesorii vehiculului. (Se recomandă ca utilizatorii să aplice eticheta pe manualul vehiculului sau pe telecomandă)\nVă rugăm să țineți apăsat butonul ON pentru a deschide cheia și a pune codul QR pe spatele cheii în cadrul de scanare',
    deviceNo: 'Numărul dispozitivului asociat',
    deviceNumber: 'Numărul dispozitivului',
    deviceTitle: 'Verificarea codurilor',
    digitalKey: 'cheie digitală',
    digitalKeyDesc: 'Nu este nevoie să purtați o cheie fizică, acceptă deblocarea vehiculului după conectarea prin APP Bluetooth (acceptată de unele modele)',
    directRelease: 'Publicarea directă',
    disagree: 'Nu sunt de acord',
    displayNumberDescription: 'Numărul de notificări afișate pe dispozitive',
    displayNumberVolume: 'Numărul de afișări',
    displayOrder: {},
    displayPicture: {},
    donwloadTemplateDescription: {},
    download: 'Descărcare',
    downloadFailFile: 'Descărcați fișierul eșuat',
    downloadSuccessful: 'Descărcarea cu succes',
    downloadTemplate: 'Descărcați șablonul',
    downloading: 'Descărcarea...',
    ebookChoice: {},
    ebookEmpty: {},
    ebookPlaceholder: {},
    ebookSwitch: {},
    ebookTitle: {},
    edit: 'Editați | ×',
    editAccountDeletExplain: 'Aviz de ștergere a contului de editare',
    editActivity: 'Editați activitatea',
    editAppRating: 'Editați mecanismul de evaluare',
    editBanner: 'Editează bannerul',
    editCanadaPrivacyPolicy: 'Editați Politica de confidențialitate Canada',
    editCanadaTelematicsPolicy: 'Editați acordul telematic din Canada',
    editCanadaUserPolicy: 'Editați acordul utilizatorului Canada',
    editDashcamHelp: 'Asistență Cameră de Bord Modificată',
    editDataDeletExplain: 'Editare aviz de ștergere a datelor',
    editExhibitionCategory: {},
    editExhibitionSeries: {},
    editFunctionIntro: {},
    editHelpConfiguration: 'Editarea configurării instrucțiunilor de ajutor',
    editInformation: 'Editați informațiile',
    editInformationCategory: 'Editați categoria de informații',
    editInformationContent: 'Editați conținutul informațiilor',
    editKolUserAuthentication: 'Editare autentificare utilizator KOL',
    editModelSeries: 'Editați seria de modele',
    editPicture: 'Editați imaginea',
    editPushConfiguration: 'Editarea configurației push',
    editRemark: 'Editează notițe',
    editServiceIntroduce: {},
    editShowroomModel: 'Editează modelele showroom-ului',
    editSuccess: 'Editat cu succes',
    editTime: 'Timp de editare',
    editUnbindingCommitment: {},
    editUser: 'editați utilizatorul',
    editVehicleModel: 'Editați modelul',
    editVehicleModelCategory: 'Editează categoria vehiculului',
    effecting: 'Activare în așteptare',
    effectiveTime: 'Data efectivă',
    electricVehicle: 'Vehicul electric',
    email: 'E-mail',
    emailAdress: 'Adresă de email',
    emailAdressTip: 'Notă:  Această adresă de email este utilizată pentru contactul cu clienții prin email.  Vă rugăm să vă asigurați că adresa de email este corectă',
    emailBindingFailed: 'Cuplarea e-mailului a eșuat',
    emailContent: 'Conținutul e-mailului',
    emailImportTemplate: 'Șablon de import pentru adresa de e-mail',
    emailImportTemplateToDownLoad: 'Adresele de e-mail pot fi importate în loturi, faceți clic pentru a descărca',
    emailList: 'Lista de e-mailuri',
    emailManage: 'Managementul e-mailului',
    emailMass: 'E-mail Blast',
    emailSearch: 'Interogare prin e-mail',
    emailSendTip1: 'Note: Be sure to add the note in blue font below at the end of your email. If the text of your email is not in English, please translate it into the language you are using before adding it.',
    emailSendTip2: 'If you want to unsubscribe from such emails, go to the CFMOTO RIDE App, click the [Me] > [Settings] > [Message notification] to turn off the [Receive email marketing] function.',
    emailSendTip3: '*Emails without added notes will not be reviewed and approved.',
    emailText: 'E-mail',
    emailTitle: 'Subiect',
    en_US: 'Engleză',
    enableStatus: 'Stare activată',
    enabled: 'permite',
    endTime: 'Timp de sfârșit',
    endTimeLargeStartTime: 'Ora de sfârșit trebuie să fie mai târziu decât ora de început',
    enterAnswer: {},
    enterCategory: {},
    enterCodeToSafeAccount: 'Pentru a asigura securitatea contului dumneavoastră, vă rugăm să confirmați informațiile contului dvs pe care doriți să îl ștergeți și introduceți parola sau codul de verificare pentru a vă verifica identitatea.',
    enterCodeToSafeData: 'Pentru a asigura securitatea datelor dvs., vă rugăm să confirmați informațiile contului dvs. și introduceți o parolă sau un cod de verificare pentru a vă verifica identitatea.',
    enterIntroduceText: {},
    enterLink: {},
    enterPopupTitle: {},
    enterQueryConditionLookData: 'După introducerea condițiilor de interogare, puteți vizualiza datele',
    enterQuestion: {},
    enterQuestionAndAnswer: {},
    enterSureUrl: {},
    enterTypeOfLanguage: {},
    enterUnbindingCommitment: {},
    entrance: {},
    errorLatAndLon: 'Latitudinea și longitudinea sunt formatate incorect, vă rugăm să verificați',
    errorLocation: {},
    es_ES: 'Spaniolă',
    estimatedTime: 'Timpul estimat',
    everySet: 'Pe setare',
    examineResultMessage: 'Vom verifica materialele aplicației cât mai curând posibil, vă rugăm să acordați atenție barei de notificare sau centrului de mesaje APP la timp.',
    example: 'precedent',
    exchange: 'Valorificați acum',
    exchangeDescription1:
      'Stimate proprietar CFMOTO, vehiculul dumneavoastră a fost asociat cu succes. Ați primit o perioadă de testare gratuită de 1 an pentru serviciile inteligente.\nVă rugăm să alegeți serviciile pe care doriți să le activați:\n- Ediție standard\n- MotoPlay Premium\nVă rugăm să citiți și să acceptați termenii și condițiile\nVizualizați „Acordul privind serviciile inteligente”\n[Confirmare]\t',
    exchangeDescription2:
      'Vă rugăm să consultați manualul electronic pentru detalii complete despre vehicul. Beneficiați de asemenea de o perioadă de testare gratuită de 1 an pentru toate serviciile inteligente CFMOTO RIDE, începând cu data primei conectări.\n [Închide] [Am înțeles]',
    exchangeDescription3:
      'Aveți XXX km de kilometraj disponibil. Valorificați acum pentru a continua utilizarea serviciului inteligent CFMOTO RIDE. Dacă nu se efectuează nicio acțiune, datele privind kilometrajul vor fi păstrate timp de 30 de zile după disocierea contului. Kilometrajul nevalorificat va fi șters automat și nu va putea fi recuperat după această perioadă. \nSunteți sigur că doriți să valorificați acum? \n[Da] [Nu]\n\n*Beneficiile aferente kilometrajului valorificat vor fi transferate odată cu vehiculul către noul proprietar.',
    exchangeDescription4: 'Aveți XXX km de kilometraj disponibil. Doriți să valorificați kilometrajul pentru a continua \nsă beneficiați gratuit de serviciul inteligent CFMOTO RIDE?\n [Da] [Nu]',
    exchangeDescription5:
      'Notificare privind serviciile inteligente\nStimate proprietar CFMOTO, Perioada gratuită de testare a serviciilor inteligente CFMOTO mai are XXX zile rămase. Dacă activați serviciul, acesta va deveni funcțional în termen de 24 de ore. Vă rugăm să verificați notificările.\n[Confirmare]',
    exchangeDescription6: 'Bucurați-vă de o experiență de condus mai bună cu MotoPlay, care oferă oglindirea ecranului și servicii de navigație prin Google Maps',
    exchangeRecords: 'Istoricul utilizărilor',
    exchangeServiceTime: 'Aveți kilometraj disponibil ce poate fi valorificat pentru ore de serviciu',
    exchangeSuccess: 'Utilizare realizată cu succes',
    exhibition: {},
    exhibitionCategory: {},
    exhibitionCategoryList: {},
    exhibitionCategorySearch: {},
    exhibitionSeries: {},
    exhibitionSeriesList: {},
    exhibitionSeriesSearch: {},
    exportContent: 'Exportați-vă conținutul',
    exportExcel: 'Exportați în Excel',
    exportLengthExceedOfMonth: 'Durata exportului nu trebuie să depășească %s luni',
    externalLink: 'Link extern',
    failed: 'Eșuat',
    failedToPreview: 'Examinarea a eșuat',
    feedBackResut: 'Rezultatele feedback-ului',
    feedBackTime: 'Timpul de feedback',
    feedBackVechle: 'Vehicul',
    feedbackAppQuestion: 'Vă rugăm să descrieți în detaliu momentul apariției, versiunea APP, modelul de telefon mobil, calea de operare și descrierea problemei pentru a ajuta la localizarea și rezolvarea rapidă a problemei!',
    feedbackDetails: 'Detalii de feedback',
    feedbackGuideDesc: 'Pentru mai multe informații, vă rugăm să ne contactați prin canalul de feedback de mai jos',
    feedbackLabelFileList: 'Vă rugăm să încărcați o fotografie',
    feedbackMapQuestion: {},
    feedbackMessageSubmitError: 'Feedback eșuat',
    feedbackOtherQuestion: 'Vă rugăm să descrieți când s-a întâmplat, cum s-a întâmplat și care este problema',
    feedbackReceived: 'Feedback primit',
    feedbackRecord: 'Înregistrarea feedback-ului',
    feedbackRulesFileListMaxSize: 'Fișierul încărcat este prea mare',
    feedbackRulesFileListOverType: 'Format neacceptat',
    feedbackSubmitTip: 'Dacă aveți întrebări sau comentarii, puteți contacta, de asemenea, Centrul de Servicii Clienți CFMOTO Mexico direct prin WhatsApp (+52 18115286003) sau e-mail (servicioalclient@cfmoto.com.mx)',
    feedbackSuggest: 'Bine ați venit pentru a face sugestii valoroase, vom lua în considerare serios ideile dvs.',
    feedbackSupplement: 'Vă rugăm să adăugați o descriere a problemei',
    feedbackText: 'Feedback',
    feedbackType: 'Tip de feedback (o singură alegere)',
    feedbackVehicleQuestion: 'Vă rugăm să descrieți când s-a întâmplat, cum s-a întâmplat și care este problema',
    female: 'Femeiesc',
    fileCountExceed: 'Numărul de fișiere depășește limita',
    fileSizeExceed: 'Dimensiunea fișierului depășește limita',
    fileUploadingPleaceWait: 'Se încarcă fișierul, așteptați',
    finalOperator: {},
    firstBindDate: 'Ora primei conectări a vehiculului',
    firstMenu: 'Meniul primului nivel',
    forcedUpgrade: 'Actualizare forțată',
    forgetPassword: 'Parolă uitată',
    fourCarOfNumber: 'Numărul de utilizatori de vehicule pe patru roți',
    fourWheel: 'Motociclete cu patru roți',
    fourWheelConfig: {},
    fourWheeler: 'Cu patru roti',
    fourWheelerMostClicks: 'Modelele de vehicule pe patru roți cu cele mai multe clicuri',
    fourWheelowner: {},
    fr_FR: 'limba franceza',
    frankfurt: 'Frankfurt',
    freeLastDayBasedata: 'Durata gratuită a ediției Standard',
    freeLastDayMotoplay: 'Durata gratuită MotoPlay',
    friday: 'Vineri',
    fuctionIntro: {},
    fullscreen: 'Ecran complet',
    funServiceIntro: {},
    function: 'Funcţie',
    functionConfiguration: {},
    functionConfigureTip: 'Această caracteristică este disponibilă numai pentru vehiculele configurate sub importator sau nume de utilizator în țara respectivă',
    functionDescription: {},
    functionDetail: {},
    functionIntroduce: 'Descrierea funcției',
    functionSetting: {},
    functionalOverview: 'Prezentare generală a funcțiilor',
    galleryEntrance: 'Intrarea în galerie',
    galleryEntranceUploadRules: 'Cerințe de format: jpg/jpeg/png, raport recomandat 4:3, dimensiunea nu mai mare de 5MB',
    gender: 'Sex',
    generalAgreementText: 'Textul acordului general',
    generalAlarm: 'Alarmă generală',
    geofence: 'Perimetru electronic',
    getCarPosition: 'Obțineți locația vehiculului la timp',
    getCode: 'Trimite',
    getExchangeRecordsError: 'Nu s-a putut obține istoricul utilizărilor',
    goCustomPage: 'Du-te la pagina personalizată',
    goOffline: 'Offline',
    goOnline: 'Online',
    goUrlLink: 'Du-te la linkul URL',
    groupTrail: {},
    groupTrailConfig: {},
    guest: 'Fără maşină',
    haveTwo: 'Ambele',
    havedWrite: 'Completat',
    havedWriteAll: 'au fost completate',
    havedWriteAllOrEmpty: 'este completat sau gol',
    helpAndFeedback: 'Ajutor și feedback',
    helpCenter: 'Centru de ajutor',
    helpConfiguration: 'Ajutor explică configurația',
    helpMessageHistoryDelete: 'Ștergeți toate înregistrările de căutare?',
    helpful: {},
    hint: 'Aluzie',
    historyDelete: 'Ștergeți toate înregistrările de căutare?',
    home: 'Pagina principală',
    homePage: 'Pagina personală',
    hour: 'Ora',
    hoursAgo: '%s ore în urmă',
    iWantEnableStoreUserQuery: 'Vreau să activez căutarea utilizatorilor magazinului',
    iWantToPostStatistics: 'Doresc să postez statistici',
    identification: 'Identificare',
    identificationText: 'Identificare',
    imageSizeExceed: 'Vă rugăm să încărcați o imagine cu o lățime și înălțime de %s',
    imageUploadFailed: 'Încărcarea imaginii nu a reușit',
    immediateRelease: 'Publicare imediată',
    immediateSend: 'Trimite acum',
    imporFailedOfTableHeader: 'Importul a eșuat. Antetul fișierului nu se potrivește',
    import: 'import',
    importDetails: 'Detalii intrebare',
    importExcel: 'Import EXCEL',
    importFail: 'Eșec la import',
    importStatus: 'Starea importului',
    importSuccessful: 'Import cu succes',
    importTemplate: 'Importați descărcarea șablonului',
    importer: 'importator',
    importerAccountOperationRecord: 'Înregistrare și operare cont importator',
    importerAvatar: 'Avatar importator',
    importerDisplayName: 'Nume afișat importator',
    importerEnquiry: 'Solicitare de informații importator',
    importerManagement: 'Gestionarea importatorului',
    importerOperationRecords: 'Înregistrări operațiuni importator',
    importing: 'Se importă...',
    inProcess: 'contramăsuri',
    inProgress: 'In progres',
    individualCenter: 'Centru individual',
    informationCategory: 'Categoria de informații',
    informationCategoryList: 'Lista categoriilor de informații',
    informationCategoryQuery: 'Interogarea categoriei de informații',
    informationContent: 'Conținutul informațional',
    informationContentList: 'Lista de conținut de informații',
    informationCotnentQuery: 'Interogarea conținutului informațiilor',
    informationCover: 'Copertă informațională',
    informationDetails: 'nformation Details',
    informationImage: 'imagine de copertă',
    informationManagement: 'Gestionarea informațiilor',
    informationTitle: 'Titlul informatiei',
    informer: 'Avertizor de integritate',
    informerId: 'Identificatorul denunțătorului',
    initialPassword: 'Parola inițială',
    inputAgreementContent: 'Vă rugăm să introduceți conținutul acordului',
    inputCannotExceed20000: 'Introduceți până la 20000 de caractere',
    inputErrorEmoji: 'Vă rugăm să nu introduceți emoticoane',
    installDeviceYouCan: 'Instalarea acestui dispozitiv vă permite să',
    installVehicleModelAdd: 'Adaugă Descrierea modelului de vehicul montat ulterior',
    installVehicleModelDescription: 'Descrierea modelului modernizat',
    installVehicleModelEdit: 'Editează Descrierea modelului de vehicul echipat ulterior',
    instrumentLastedVersion: 'Ecran TFT nu este nevoie de upgrade',
    instrumentupgrade: 'Upgrade ecran TFT',
    inteligentServiceReminder: 'Memento privind serviciile inteligente',
    intelligentInternetServiceIntroduction: 'Introducerea serviciului',
    intelligentServiceAgreement: 'Acordul privind serviciile inteligente',
    intelligentServices: 'Servicii inteligente (informații despre vehicul, date de rulare, actualizări OTA)',
    introText: {},
    introduction: 'Introducere',
    invalidVercode: 'Cod de verificare invalid',
    invoicePreview: 'Previzualizare factură',
    invoicing: 'Facturare',
    invoicingFailed: 'Facturare eșuată',
    invoicingSucceeded: 'Facturare reușită',
    iovNotice1: 'Funcțiile de mai sus se bazează pe dispozitivul de rețea al vehiculului (T-Box), vă rugăm să consultați distribuitorul local pentru a cumpăra și instala',
    iovNotice2: 'Funcțiile de mai sus sunt diferite în funcție de configurația fiecărui model și de regiunea în care se află. Vă rugăm să consultați distribuitorul local pentru detalii.',
    iovNotice3: 'Vă rugăm să salvați și să înregistrați în avans numărul dispozitivului, care este necesar la legarea dispozitivului. După finalizarea legării și instalării, puteți experimenta mai multe funcții',
    isHelpful: 'Ajută?',
    isStop: {},
    isSupportedChildOwnerOffMapDown: {},
    isSupportedNoOwnerOffMapDown: {},
    isSupportedOffMapDown: {},
    it_IT: 'Italiană',
    iterativeVehicleFunctions: 'Părțile principale ale vehiculului pot fi actualizate online de la distanță pentru a itera continuu funcțiile vehiculului',
    jumpSettings: 'Setări de salt',
    jumpTarget: {},
    jumpToWeb: {},
    jumpUrl: {},
    justNow: 'Chiar acum',
    keySharing: 'Cheie digitală și partajare cheie',
    kolUser: 'Utilizator KOL',
    kolUserList: 'Lista utilizatorilor KOL',
    kolUserManagement: 'Gestionarea utilizatorilor KOL',
    kolUserQuery: 'Interogare utilizatori KOL',
    language: 'Limba',
    language1: 'Limba relevantă',
    languages: 'limba',
    lastLoginTime: 'Ultima timp de conectare',
    lastModifiedBy: 'Modificat ultima dată de',
    lastUpdateTime: 'Timpul ultimei actualizări',
    latitude: 'Latitudine',
    launchActivity: 'Lansați activitatea',
    likeNumber: 'Îi place',
    linkAddress: {},
    linkUrlDescription: {},
    linkedOrder: 'Comandă asociată',
    listDisplayImages: 'Afișarea listei',
    listOfImporters: 'Lista importatorilor',
    listOfQuestion: {},
    listShowStoreCoverPic: 'Lista arată imaginea de copertă a magazinului',
    loadMore: 'Încarcă mai mult',
    loadSuccess: 'Se încarcă complet',
    loading: 'Se încarcă',
    locationFail: {},
    log: 'Jurnal',
    login: 'Autentificare',
    loginCountry: 'Conectați-vă la țară/regiune',
    loginSuccessfully: 'Conectați-vă cu succes',
    logout: 'Deconectați-vă',
    longitude: 'Longitudine',
    loosing: 'Date răcoritoare...',
    lowCompatibleVersion: 'Versiune minimă compatibilă',
    mail: 'Email',
    male: 'Bărbătesc',
    manualReviewStatus: 'Starea revizuirii manuale',
    mapManage: {},
    marketDataOfdealerStores: 'Date de piață ale magazinelor dealerilor',
    masteringCyclingData: 'Date despre călărie',
    maximum: 'Max.',
    maximumBannerCountTip: 'Un număr maxim de %s bannere pot fi online în același timp.  Vă rugăm să eliminați mai întâi cel puțin una.',
    maximumMileage: 'Kilometraj maxim valorificabil',
    maximumValue: 'Maxim',
    menuFunctionName: 'Numele funcției de meniu',
    menuIcon: 'Pictograma meniului',
    messagePush: 'Mesajul Push',
    messagePushDeleteAsk: 'Sunteți sigur că doriți să ștergeți acest push?',
    messagePushDownloadTemplate:
      'Vă rugăm să descărcați mai întâi șablonul și să încărcați fișierul după ce ați completat fișierul șablon. Dimensiunea fișierului este limitată la 2M. Dacă trimiterea nu reușește, vă rugăm să reduceți conținutul în mod corespunzător',
    messageWithdrawAsk: 'Vrei să retrageți acest push?',
    middle: 'mijloc',
    min: 'Min',
    minAgo: '%s min în urmă',
    minimum: 'Min.',
    minimumValue: 'Minim',
    modelDetail: 'Detalii model',
    modifyFail: 'Modificarea a eșuat',
    modifyPassword: 'Modificați parola',
    modifySuccess: 'Editare reușită',
    monday: 'Luni',
    more4pic1video: 'Maxim 4 imagini / 1 videoclip',
    moreDetailsConsultDealerStore: 'Pentru mai multe detalii, vă rugăm să contactați dealerul dumneavoastră',
    morning: 'Dimineață',
    motoPlay: 'MotoPlay (serviciu de navigație și oglindire a ecranului bazat pe Google Maps)',
    motoPlayAgreement: 'Starea Acordului MotoPlay',
    motoplatNavigationScreen: 'MotoPlay – Oglindire ecran și navigație',
    motoplayServicePay: 'Plată pentru MotoPlay',
    motoplayServiceResetTimeRule: 'Ora de resetare MotoPlay nu poate fi ulterioară timpului curent',
    motorcycle: 'două roți',
    moveDown: 'Deplasarea în jos',
    moveLongPressMap: {},
    moveMapSelectPoint: {},
    moveTo: 'Mutare în',
    moveToBottom: 'Deplasarea în partea de jos',
    moveToTop: 'Mutare în partea de sus',
    moveToTopStatus: 'Fixați postarea',
    moveTop: 'Setările de top',
    moveUp: 'Deplasare în sus',
    multimedia: 'Multimedia',
    mustInteger: {},
    mute1Day: 'Tăcere timp de 1 zi',
    mute2Days: 'Tăcere timp de 2 zile',
    mute30Days: 'Tăcere timp de 30 zile',
    mute3Days: 'Tăcere timp de 3 zile',
    mute7Days: 'Tăcere timp de 7 zile',
    muting: 'Mut',
    nameOfImporter: 'Numele importatorului',
    navigation: 'Navigare pe hartă',
    nearLoginTime: 'Ultimul timp de autentificare',
    needPopup: 'Aveți nevoie de o fereastră pop-up',
    negativeNum: 'Recenzie proastă',
    networkException: 'Excepție de rețea',
    newAddFail: 'Adăugarea a eșuat',
    newAddSuccess: 'adăugat cu succes',
    newBanner: 'Bannere noi',
    newCancellationAgreement: 'Nou acord de anulare',
    newEmail: 'Email nou',
    newEmailEqualsValidate: 'Adresa de e-mail nouă nu poate fi aceeași cu adresa de e-mail inițială',
    newFunctionIntro: {},
    newMenuFunction: 'Funcție nouă de meniu',
    newModelSeries: 'Noua serie de modele',
    newPassword: 'Parola nouă',
    newPasswordNotEqual: 'Noua parolă introdusă de două ori este inconsecventă, vă rugăm să reintroduceți',
    newQuestionType: {},
    newStoreNumber: 'Numărul de magazine noi',
    newTopic: 'Temă nouă',
    newUnbindingCommitment: {},
    nextStep: 'Următorul',
    nickName: 'Poreclă',
    no: 'Nu',
    noContent: 'Nu există conținut similar',
    noContent2: 'Sugerați schimbarea cuvintelor cheie sau',
    noData: 'Nu există date',
    noExchangeRecord: 'Niciun istoric de valorificare momentan',
    noFeedbackRecord: 'Nu există înregistrări de feedback în acest moment.',
    noJump: 'Fără săritură',
    noLog: 'Fără jurnal',
    noMores: 'Nu mai există',
    noNeedPopup: 'Nu sunt necesare ferestre pop-up',
    noOkToFeedback: 'Nerezolvat, vreau să dau feedback',
    noOwnerScore: 'Evaluări non-proprietari',
    noPass: 'Respingere',
    noSendPeople: 'Fără expeditor',
    noSortingPermission: 'Nicio permisiune de sortare',
    noSupportMapDown: {},
    noThisPermission: 'Nicio permisiune pentru această operațiune',
    noUserSelected: 'Niciun utilizator selectat, nu poate fi trimis',
    nofiledSeviceContent: {},
    nonOwner: 'Non-proprietar',
    nonVehicleOwnerCharged: {},
    none: 'Niciunul',
    normal: 'Normal',
    notAllowImageAndVideo: 'Video nu poate fi selectat atunci când se selectează imagini',
    notAllowed: 'Nu este permis',
    notBeLessOrEqual: 'Nu trebuie să fie mai mic sau egal cu',
    notDeleted: 'Nu a fost deconectat',
    notDistributedYet: 'Nu a fost emisă încă',
    notEnabled: 'Nu este activat',
    notHelpful: {},
    notLessThan: 'Nu trebuie să fie mai mic de',
    notRecommended: 'Nu este recomandat',
    notReleasedYet: 'Nu a fost încă lansat',
    notStarted: {},
    'notSupportT-Box': 'Ne pare rău, vehiculul dumneavoastră nu suportă T-Box',
    notTop: 'Nu a ajuns în vârf',
    notice: 'Înștiințare',
    noticeText1: 'Dear CFMOTO users,',
    noticeText2:
      'Hello! We sincerely thank you for your continuous support and trust in CFMOTO. We are committed to enhancing service quality and implementing innovative improvements, and we have made business adjustments due to this commitment. As of 08/10/2024, we will discontinue the CFMOTO RIDE App (the "App") in the United States. In its place, we have launched the brand-new CFMOTO RIDESYNC App. We hope you continue to enjoy our services through this new app.',
    noticeText3: 'Important notes:',
    noticeText4: '1. From today on, this app will only be available for bound CFMOTO vehicles in the United States and no longer support binding new vehicles. If you need to bind a new vehicle, please download and use the CFMOTO RIDESYNC App.',
    noticeText5:
      '2. We strongly recommend that you download and use the CFMOTO RIDESYNC App before 08/10/2024 so that you can continue enjoying our services seamlessly. We provide you with a convenient data migration service. You can choose to migrate all data retained in this App to the CFMOTO RIDESYNC App to preserve your personal information, vehicle information and past service records. We will ensure your data security and privacy during the migration process. If you want to use the CFMOTO RIDESYNC App without migrating data, you can re-register with the CFMOTO RIDESYNC App to use the new services. Click on the button below to learn how to download and use the CFMOTO RIDESYNC App.',
    noticeText6:
      '3. Please note that after 08/10/2024, you will no longer be able to use the relevant services of the App in the United States. Meanwhile, we will delete all personal data generated during your use of the App according to the relevant laws and regulations.',
    noticeText7:
      'We are fully aware that this change may cause temporary inconvenience to you, but we believe that with this service upgrade, you will have a richer and more satisfying user experience. If you encounter any issues or have questions during this process, we will always be here to help. Thank you for your understanding and cooperation, and we look forward to serving you in the CFMOTO RIDESYNC App.',
    noticeText8: 'Wish you a happy life!',
    notzero: 'Numerele versiunilor nu pot fi toate 0',
    obtainVerificationCode: 'Obținere cod de verificare',
    officiaAndKolList: 'Listă oficială/KOL',
    officialAccount: 'Cont oficial',
    officialAccountAuth: 'Autentificare cont oficial',
    officialIrKOLSearch: 'Căutare oficială/KOL',
    officialKolAuth: 'Autentificare oficială/KOL',
    offline: 'Deconectat',
    offlineAlready: 'Offline',
    offlineTime: 'Timp offline',
    offlineTimeMustBeGreaterThan: 'Timpul offline trebuie să fie mai mare de',
    ok: 'O.K',
    oldPassword: 'Parola veche',
    onLineAlready: {},
    oneMonths: 'O lună',
    oneYear: 'Un an',
    online: 'Pe net',
    onlyFourWheel: 'Numai cu patru roți',
    onlyTwoWheel: 'Doar cu două roți',
    openEveryCount: {},
    openEveryDay: {},
    openProductType: {},
    operationRecord: 'Înregistrarea operațiunii',
    operationTime: 'Timp de operare',
    operations: 'Operațiuni',
    operator: 'Operator',
    operattor: 'Operator',
    opreate: {},
    opreateFunSet: {},
    opreateFunSetAdvert: {},
    opreateFunSetAdvertAdd: {},
    opreateFunSetAdvertEdit: {},
    opreateFunSetAdvertView: {},
    optionalUpgrade: 'Actualizare opțională',
    orderFeedBackNum: 'Număr de feedback-uri pentru comandă',
    orderList: {},
    orderMange: {},
    orderNum: {},
    orderQuestion: 'Descrieți momentul și detaliile apariției problemei și încărcați una sau mai multe capturi de ecran ale acestei probleme. Pentru problemele de plată, vă rugăm să încărcați și dovada debitării',
    originalEmail: 'Email original',
    otaUpgradeVehicle: 'Vehicul de upgrade OTA',
    otaUpgradeVehicleDesc: 'Componentele principale ale vehiculului pot fi actualizate de la distanță pentru a repeta continuu performanța vehiculului.',
    other: 'Alt',
    over: 'peste',
    owner: 'Ia o maşină',
    ownerIdHomepageImage: 'Pagina principală a cărții de identitate, permisului de conducere sau pașaportului care conține informații personale de identificare.',
    parameterConfiguration: 'Configurarea parametrilor',
    partialImportFailed: 'Import parțial eșuat',
    pass: 'Aprobare',
    passValidateDeleteAccount: 'Verificarea identității a avut succes! Faceți clic pe butonul Trimiteți cererea din partea de jos pentru a solicita ștergerea contului',
    password: 'Parolă',
    passwordRuleText: '8-20 de caractere, trebuie să conțină litere engleze mari și mici, cifre, caractere speciale',
    passwordRules: 'Reguli de parolă',
    paySetting: {},
    payStrategy: {},
    paymentLastDayBasedata: 'Durata plătită a ediției Standard',
    paymentLastDayMotoplay: 'Durata plătită MotoPlay',
    peleaseEnterProvince: 'Vă rugăm să introduceți o provincie/stat',
    pendSend: 'In asteptarea',
    pending: 'În așteptare.',
    pendingSubmit: 'În așteptarea trimiterii',
    permanentMuting: 'Mutat permanent',
    phoneModel: 'Numărul modelului',
    phoneNum: 'număr de telefon',
    phoneNumber: 'Număr de telefon',
    phoneOrEmail: 'Număr de telefon/e-mail',
    phoneOrEmailImportTemplate: 'Șablon de import pentru numărul de telefon mobil/adresa de e-mail',
    phoneOrEmailNotRegistered: 'Acest număr de telefon mobil sau această adresă de e-mail nu este înregistrată',
    phoneOrEmailOrUserId: 'Număr de telefon/adresă de e-mail/ID utilizator',
    picture: 'Imagine',
    pl_PL: 'Lustrui',
    pleaseAddImage: 'Vă rugăm să adăugați fișiere imagine',
    pleaseAddVideoFile: 'Vă rugăm să adăugați fișiere video',
    pleaseEnter: 'Vă rugăm să introduceți',
    pleaseEnterAccountInfo: 'Vă rugăm să introduceți informațiile contului',
    pleaseEnterAmount: {},
    pleaseEnterCity: 'Vă rugăm să introduceți un oraș',
    pleaseEnterEmail: 'Te rugam sa introduci adresa ta de email',
    pleaseEnterEmailAdress: 'Vă rugăm să introduceți adresa de email',
    pleaseEnterIntro: 'Vă rugăm să introduceți introducerea',
    pleaseEnterLatAndLong: 'Vă rugăm să introduceți latitudinea și longitudinea',
    pleaseEnterNewPassword: 'Introduceți noua parolă',
    pleaseEnterPassword: 'Vă rugăm să introduceți parola',
    pleaseEnterPhone: 'Vă rugăm să introduceți numărul dvs. de telefon',
    pleaseEnterQuestionDescription: 'Vă rugăm să introduceți o descriere a problemei dvs.',
    pleaseEnterRealname: 'Vă rugăm să introduceți numele dvs. real',
    pleaseEnterRemark: 'Vă rugăm să introduceți observații',
    pleaseEnterServePhone: 'Vă rugăm să introduceți numărul de telefon de serviciu',
    pleaseEnterStoreAddressDetail: 'Vă rugăm să introduceți adresa detaliată',
    pleaseEnterStoreIntroduce: 'Vă rugăm să introduceți prezentarea magazinului',
    pleaseEnterStoreName: 'Vă rugăm să introduceți numele magazinului',
    pleaseEnterStoreRemarkName: 'Vă rugăm să introduceți numele observației magazinului',
    pleaseEnterTitle: 'Vă rugăm să introduceți un titlu',
    pleaseEnterUsername: 'Vă rugăm să introduceți numele de utilizator',
    pleaseEnterVercode: 'Vă rugăm să introduceți codul de verificare',
    pleaseEnterVersion: 'Vă rugăm să introduceți numărul versiunii',
    pleaseEnterVersionIntroduction: 'Introduceți introducerea versiunii',
    pleaseEnterVideoDetail: 'Vă rugăm să introduceți detaliile videoclipului',
    pleaseEnterVin: 'Vă rugăm să introduceți VIN-ul',
    pleaseInputWord: 'Vă rugăm să introduceți cuvântul cheie',
    pleaseLoginFirst: 'Vă rugăm să vă conectați mai întâi',
    pleaseRepeatNewPassword: 'vă rugăm să repetați parola nouă',
    pleaseSelect: 'vă rugăm să alegeți',
    pleaseSelectAuthAccount: 'Selectează contul de autentificare',
    pleaseSelectBusinessHours: 'Vă rugăm să selectați orele de deschidere',
    pleaseSelectCity: 'Vă rugăm să selectați orașul',
    pleaseSelectCountry: 'Vă rugăm să selectați țara',
    pleaseSelectCurrency: {},
    pleaseSelectMatchingMultimediaContent: 'Vă rugăm să selectați conținutul multimedia corespunzător',
    pleaseSelectPayChannel: {},
    pleaseSelectProblemWhere: 'Vă rugăm să selectați un scenariu în care apare problema',
    pleaseSelectProducType: {},
    pleaseSelectProvince: 'Vă rugăm să selectați provincia/statul',
    pleaseSelectQueType: 'Vă rugăm să selectați tipul de întrebare',
    pleaseSelectReportReason: 'Vă rugăm să selectați motivul raportării',
    pleaseSelectService: 'Vă rugăm să selectați mai întâi un serviciu',
    pleaseSelectStatus: 'Vă rugăm să selectați statutul',
    pleaseSelectStoreType: 'Vă rugăm să selectați tipul de magazin',
    pleaseSelectTimedSendTime: 'Vă rugăm să selectați ora de trimitere',
    pleaseSelectUserTheList: 'Vă rugăm să selectați un utilizator din listă',
    pleaseSelectVehicle: 'Vă rugăm să selectați un vehicul',
    pleaseSelectVehicleConfig: {},
    pleaseSelectlinkedOrder: 'Vă rugăm să selectați o comandă asociată.',
    pleaseSelectupgradeType: 'Vă rugăm să selectați metoda de actualizare',
    pleaseSureType2: 'Asigurați-vă că totul din',
    pleaseUpload: 'Vă rugăm să încărcați',
    pleaseUploadPicVideo: 'Vă rugăm să încărcați imagini/video',
    pleaseUserTimeFill: 'Vă rugăm să completați conform timpului utilizatorului final',
    popUpFrequencyType: 'Formular de fereastră pop-up',
    popUpFrequencyValue: 'Frecvența pop-up-urilor',
    popUpFrequencyValueValid: 'Vă rugăm să selectați zilele de frecvență',
    popUpReminder: 'Dacă să apară un memento',
    popupArea: 'gama de utilizatori pop-up',
    popupCreate: {},
    popupDayOne: 'O dată pe număr stabilit de zile',
    popupEdit: {},
    popupFrequency: {},
    popupManagement: {},
    popupOne: {},
    popupPosition: {},
    popupStatus: {},
    popupTarget: {},
    popupTime: {},
    popupTitle: {},
    positiveNum: 'Recenzii bune',
    postComment: 'Lasă un comentariu',
    postContent: 'Conținutul postării',
    postId: 'ID post',
    postList: 'Lista posturilor',
    postManagement: 'Gestionarea posturilor',
    postSearch: 'Mesaj căutare',
    posts: 'Mesaje',
    precautionText1:
      'Hello! As you have learned that we will discontinue the CFMOTO RIDE App (hereinafter referred to as "the App") in the United States from 08/10/2024, to assist you with this change, please take note of the following important matters:',
    precautionText2: '1. From today on, you will not be able to bind a new vehicle through the APP to enjoy relevant vehicle services.',
    precautionText3: '2. To ensure a smooth transition to the new service, we have provided an entry at the top of the vehicle page in this App. You can learn how to download and use the CFMOTO RIDESYNC App at any time through that entry.',
    precautionText4:
      '3. Please note that once the service ceases to take effect, you will no longer be able to enjoy any services of the App in the United States. At the same time, we will delete all personal data generated during your use of the App in accordance with relevant laws and regulations. This means that we will not be able to respond to any of your requests for data after the service is discontinued.',
    precautionText5:
      'We understand that this change may cause inconvenience to you, but we are committed to continuously protecting your data security and privacy. We encourage you to take early action to download and start using the CFMOTO RIDESYNC App in a timely manner so that you can continue to enjoy the quality service provided by CFMOTO. If you have any questions or need assistance in this process, please do not hesitate to contact us. We look forward to serving you in the CFMOTO RIDESYNC App.',
    privacyContent: 'Politica de confidențialitate Detalii conținut',
    privacyPolicy: 'Politica de Confidențialitate',
    privacyPopupAgree: 'Obțineți din nou consimțământul utilizatorului cu privire la politica de confidențialitate printr-o fereastră pop-up',
    privacyVersion: 'Versiunea politicii de confidențialitate',
    privacyVersionList: 'Lista versiunilor politicii de confidențialitate',
    problemaDes: 'Descrierea problemei',
    processMethod: 'Metode de procesare',
    processReason: 'Motivul prelucrării',
    processReasonDetails: 'Detalii privind motivul prelucrării',
    processRecord: 'Prelucrarea înregistrărilor',
    processReport: 'Rapoarte de proces',
    processSolution: 'Soluții de prelucrare',
    processUser: 'Manipularea utilizatorilor',
    processed: 'Prelucrate',
    productDetails: {},
    productTime: 'timpul de productie',
    prohibitDecimalsAndNegative: {},
    pt_PT: 'portugheză',
    publishInformation: 'Publicați informații',
    publishPosts: 'Publicarea unei postări',
    pullBefore: 'Trageți în jos pentru a reîmprospăta.',
    pulling: 'Eliberați reîmprospătarea acum',
    purchaseAndInstall: 'Cumpărați și instalați',
    pushConfiguration: 'Configurație push',
    pushContent: 'Push conținut',
    pushList: 'Listă de push',
    pushMode: 'Mod de push',
    pushNow: 'Acum push',
    pushQuery: 'Interogare push',
    pushRecord: 'Înregistrarea push',
    pushScope: 'Domeniul push',
    pushTime: 'Timp de push',
    pushTimeDifferenceAsk: 'Ora de trimitere pe care o alegeți poate face ca unii utilizatori să nu poată primi acest push din cauza diferențelor de timp. Ești sigur că vrei să salvezi?',
    pushTitle: 'Titlu de push',
    pushed: 'Impins',
    pushing: 'Pushing',
    quantity: 'Cantitate',
    query: 'Căutare',
    question: {},
    questionInquiry: {},
    questionType: 'Tipul de întrebare',
    questionTypeList: {},
    questionTypeTemplate: {},
    quickRelease: 'Eliberare rapidă',
    ranking: 'Clasament',
    ratingWarn1:
      'Pentru utilizatorii deținătorilor de vehicule, controlul serviciului inteligent corespunzător țării/regiunii din fundal de gestionare nu a fost activat sau serviciul serviciului inteligent nu a expirat după ce a fost pornit. Vehiculul este online și are',
    ratingWarn2: 'sau mai multe înregistrări complete de călătorie (începutul și sfârșitul fiecărei curse sunt un eveniment raportat), va apărea o fereastră pop-up când utilizatorul iese din My Cycling și revine la pagina de pornire.',
    reUpgrade: 'Reîncercați',
    readAgree: 'Citiți și sunteți de acord cu',
    readAndAgree: 'Vă rugăm să citiți și să fiți de acord',
    readAndAgreeTo: 'Am citit și sunt de acord cu',
    readDeleteStep: 'înțelegeți  tipurile de date pe care noi le vom șterge sau păstra și orice perioade suplimentare de păstrare',
    realname: 'Nume real',
    reasonForReport: 'Motivul',
    receiveCarReminderMessage: 'Primiți alerte privind mesajele vehiculului',
    rechargeAmount: {},
    rechargeChannel: {},
    rechargeStatus: {},
    rechargeTime: {},
    recharged: {},
    recipients: 'Destinatar',
    recipientsNum: 'Domeniul de aplicare al destinatarului',
    recommended: 'Recomanda',
    recommendedStatus: 'Statut recomandat',
    redeemableServiceHours: 'Ore de serviciu ce pot fi valorificate',
    redemptionMileage: 'Kilometraj disponibil pentru răscumpărare',
    redemptionRatio: 'Rată de valorificare',
    redemptionTime: 'Data valorificării',
    redirectUrl: {},
    refreshInterval: 'Interval de reîmprospătare',
    refreshSend: 'retrimite',
    refundFailed: {},
    refunded: {},
    refunding: {},
    refused: 'Respins',
    registerDate: 'Ora de înregistrare',
    rejected: 'Respins.',
    releaseContent: 'Publicați conținut',
    releaseMethod: 'Metodă de lansare',
    releaseMute: 'Eliberați tăcerea',
    releaseTime: 'Timpul de eliberare:',
    released: 'elibera',
    releasedBy: 'Lansat de',
    remainServiceHavExpired: 'Timpul rămas până la expirarea serviciului inteligent',
    remainingAvailableMileage: 'Kilometraj disponibil rămas',
    remark: 'Note',
    rememberPassword: 'Amintiți-vă parola',
    reminder: 'Memento',
    remove: 'Șterge',
    removeOnlinUpgrade: 'Vehicul de upgrade online la distanță',
    repeatNewPassword: 'Repetați noua parolă',
    replaceTBOX: 'Înlocuiește TBOX',
    replied: 'Răspuns',
    reply: 'Răspunde',
    report: 'Raport',
    reportList: 'Lista de rapoarte',
    reportManagement: 'Gestionarea rapoartelor',
    reportReason: 'Motivul raportării',
    reportReasonDetails: 'Detalii privind motivul raportului',
    reportReasonPlaceholder: 'Scrieți ce doriți să raportați, 0-1500 de cuvinte',
    reportSearch: 'Căutare raport',
    reportSuccessful: 'Raportați cu succes, ne vom ocupa de el cât mai curând posibil',
    reportTime: 'Timpul de raportare',
    reportType: 'Tipul de raport',
    reportedContent: 'Conținutul raportului',
    reportedUser: 'Raportați un utilizator',
    reportedUserId: 'ID-ul de utilizator al raportului',
    requestTimedOut: 'Cererea a expirat',
    resend: 'Retrimitere',
    resendTo: 'Retrimite la',
    reset: 'Resetare',
    resetItem: 'Element de resetare',
    resetTime: 'Ora de resetare a serviciilor smart',
    resetWarn: 'După resetare, perioada gratuită pentru serviciile smart ale vehiculului va fi recalculată și va intra în vigoare în funcție de ora curentă (ora browser-ului). Confirmați resetarea?',
    return: 'Înapoi',
    review: 'Revizuire',
    reviewApproved: 'Revizuirea a trecut',
    richText: {},
    ro_RO: 'Română',
    roleDescription: 'Descrierea rolului',
    roleName: 'Nume rol',
    rolePermission: 'Permisiune rol',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: 'ebook',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: 'Rusă',
    safeRemind: 'Pentru a proteja securitatea contului dvs., vă rugăm să nu trimiteți aici informații personale sensibile, cum ar fi parolele conturilor etc.',
    satelliteMap: 'Harta prin satelit',
    saturday: 'Sâmbătă',
    save: 'Salvează',
    saveAndPreview: 'Salvați și previzualizați',
    saveAsDraft: 'Salvează ca schiță',
    saveFail: 'Nu a reușit să salveze',
    savePicture: 'Salvează poza',
    saveSettings: 'Salvează setările',
    saveSuccess: 'Salvat cu succes',
    saveVideo: 'Salvați videoclipul',
    scanQrcodePreview: 'Scanați codul QR de mai jos cu telefonul mobil pentru a previzualiza',
    screenNavigationGuidance: 'Setări de boot',
    sdkStatement: 'Declarație SDK',
    search: 'Căutare',
    searchRecords: 'Căutare istorică',
    secondaryMenu: 'Meniu secundar',
    securityMessage: 'Informațiile de mai sus sunt utilizate doar în scopul verificării identității, CFMOTO protejează informațiile dumneavoastră.',
    securityServices: 'Servicii de securitate (localizare în timp real, perimetru virtual, alertă defecțiuni)',
    select: 'Selecta',
    selectAccount: 'Selectează cont',
    selectAll: 'Selectează tot',
    selectAuthentication: 'Selectare autentificare',
    selectChannelType: 'Vă rugăm să selectați un canal de feedback',
    selectCountry: 'Selectați țara',
    selectData: 'Vă rugăm să selectați datele pe care doriți să le ștergeți și să faceți clic pe butonul Trimitere din partea de jos pentru a trimite cererea de ștergere a datelor.',
    selectDate: 'Selectați Data',
    selectEnableStatus: {},
    selectFeedBackState: 'Selectați starea procesării feedback-ului',
    selectFeedbackType: 'Vă rugăm să selectați un tip de feedback',
    selectJumpTarget: {},
    selectLanguage: 'Vă rugăm să selectați limba',
    selectOneCarType: 'Selectați cel puțin un model',
    selectPoint: {},
    selectPopupFrequency: {},
    selectPopupPosition: {},
    selectPopupTarget: {},
    selectPopupTime: {},
    selectRejectReason: 'Vă rugăm să selectați un motiv pentru respingere',
    selectTheLanguage: 'Selectați limba',
    selectTime: 'selectați ora',
    selectUser: 'Selectați utilizatori',
    selectVehicle: 'Selectați vehiculul',
    selectedMileage: 'Kilometraj selectat',
    selectedMileageRedemption: 'Selectați kilometrajul pentru răscumpărare',
    selectionOfImporter: 'Selecția importatorului',
    sendNumberDescription: 'Numărul de dispozitive valide pentru care AWS Cloud a creat sarcini de trimitere;',
    sendNumberDescription0: 'Dintre dispozitivele țintă eficiente, serverul Aurora creează efectiv cu succes numărul de dispozitive pentru transmite sarcinilor',
    sendNumberVolume: 'Numărul de trimiteri',
    sendTo: 'Trimite la',
    sendType: 'Modul de trimitere',
    sendUserNum: 'Numărul de trimiteri',
    sending: 'În trimitere',
    serial: 'Nu.',
    seriesBackground: {},
    seriesDesc: {},
    seriesIntroduction: 'Introducere în serie',
    seriesName: {},
    seriesShowcase: 'Showcase de serie',
    seriesUplodImgRule: {},
    seriousAlarm: 'Alarmă gravă',
    serviceDays: 'Zile de serviciu',
    serviceDetail: 'Detalii despre serviciile inteligente',
    serviceExpiration: 'Serviciile dumneavoastră inteligente au expirat',
    serviceHavExpired: 'Serviciile inteligente au expirat',
    serviceIntroduction: 'Introducerea serviciului',
    serviceReset: 'Resetare Serviciu Inteligent',
    serviceText: 'Serviciu',
    settingSuccess: 'Setați cu succes',
    shareNumber: 'Număr de acțiuni',
    sheet: 'Zhang',
    show: 'Vedere',
    showPicturesOfVideos: 'Afișați imagini/videoclipuri',
    showToast1: 'Kilometraj insuficient pentru 1 zi de serviciu',
    showToast2: 'Minim 1 zi de serviciu necesară',
    showToast3: 'Parametrul nu există sau este nul',
    showroomModel: 'Modele de showroom',
    showroomModelList: 'Lista modelelor de showroom',
    showroomModelQuery: 'Întrebare model showroom',
    showroomUploadRules: 'Cerința pentru formatul imaginii este jpg/jpeg/png, raportul imaginii este 9:19,5, dimensiunea nu depășește 5MB și dimensiunea videoclipului nu depășește 50MB',
    signOut: 'Încheiat automat',
    singapore: 'Singapore',
    sixMonths: 'Șase luni',
    slideToRight: 'glisați spre dreapta',
    smartServices: 'Servicii inteligente',
    someUser: 'Unii utilizatori',
    sort: 'Sortare',
    source: 'Sursa datelor',
    sr_YU: 'sârb',
    standardAgreement: 'Starea Acordului Standard Edition',
    startCalculateTimeBasedata: 'Timpul de resetare al ediției Standard',
    startCalculateTimeMotoplay: 'Timpul de resetare MotoPlay',
    startChecking: 'Începe verificarea',
    startTime: 'Timp de începere',
    statisticalTime: 'Timpul statisticilor',
    status: 'Stare',
    stepText1: 'To ensure smooth data migration and use of the CFMOTO RIDESYNC App, we recommend that you follow these steps:',
    stepText2: '1. First, you can click the button below [Download CFMOTO RIDESYNC] or directly open Apple Store/Google Play to search and download CFMOTO RIDESYNC App;',
    stepText3: '2. After downloading and installing, please open the CFMOTO RIDESYNC App to enter the login page. On this page, you need to log in with your existing CFMOTO RIDE account and password;',
    stepText4:
      '3. When you enter your account and password correctly, the App will pop up a prompt window asking whether to start the data migration. When you click OK, the data migration starts immediately and this process is uninterrupted. If you select "Cancel" in this step, you will not be able to continue logging into the App.',
    stepText5: '4. After clicking OK, the data migration will start immediately, and the process is uninterruptable. If that fails, contact it@cfmoto.com',
    stepText6:
      '5. After the data migration is completed, you will automatically enter the vehicle homepage of the CFMOTO RIDESYNC App. At this moment, you can start to use all functions of the App normally, and you will be able to access all the data you previously retained in the CFMOTO RIDE App.',
    stepText7:
      '*Important notes: Be sure to log in the CFMOTO RIDESYNC App with your CFMOTO RIDE account to ensure successful data migration. If you choose to register a new account or log in with another account, your data will not be migrated. In addition, after successful data migration, your original CFMOTO RIDE account will no longer support login to the CFMOTO RIDE App. Please operate carefully to ensure the safe migration of your data.',
    stop: {},
    store: {},
    storeAddressCountryTip: 'Notă:  Această adresă a magazinului este singura bază pentru ca utilizatorii să vă găsească.  Vă rugăm să completați cu atenție pentru a vă asigura că adresa este corectă',
    storeAddressDetail: 'Adresă magazin',
    storeAddressDetailTip: 'Exemplu: adresă detaliată:  Str. Wuzhou, Nr. 116, Zona de Dezvoltare Economică Yuhang, Hangzhou',
    storeAddressPosition: 'Latitudine și longitudine',
    storeAddressPositionTip:
      'Longitudine: partea întreagă a longitudinii este un număr întreg cuprins între -180 și 180, iar partea zecimală este o zecimală care nu depășește 15 cifre.\nLatitudine: partea întreagă a latitudinii este un număr întreg cuprins între -90 și 90, iar partea zecimală nu depășește 15 zecimale.',
    storeBusinessType: 'Tip de magazin',
    storeImage: 'Imagine magazin',
    storeImportTemplateText:
      'Vă rugăm să descărcați șablonul, să completați informațiile despre magazinul dealerului în fișierul șablon și apoi să încărcați fișierul; dimensiunea fișierului este limitată la 1 MB; dacă trimiterea eșuează, vă rugăm să reduceți conținutul sau să îl încărcați în loturi',
    storeIntroduce: 'Prezentare magazin',
    storeList: 'Listă de magazine',
    storeMange: 'Managementul magazinului',
    storeName: 'Nume magazin',
    storeNameTip: 'Notă:  Vă rugăm să selectați o limbă suportată de sistem pentru a completa numele magazinului',
    storeQueryUserStatistics: 'Interogare statistică a utilizatorilor magazinului',
    storeRemarkName: 'Nume observație magazin',
    storeRemarkNameTip: 'Notă:  Dacă limba suportată de sistem nu vă satisface nevoile, puteți introduce aici numele observației magazinului în limba dorită.',
    storeSearch: 'Interogare magazine',
    storeServicePhone: 'Numărul de telefon al serviciului',
    storeServicePhoneTip: 'Notă:  Acest număr este utilizat pentru contact telefonic cu clienții, vă rugăm să vă asigurați că numărul de telefon este corect.',
    storeServiceTime: 'Timp de deschidere',
    storeStatistics: 'Statistici ale magazinului',
    storeUploadImageRequire: 'Cerințe de format de imagine pentru jpg/jpeg/png, se recomandă ca dimensiunea unei singure imagini să nu depășească 5MB, un singur import de până la 9, poate fi importat mai mult de o dată, numărul total de nu mai mult de 9',
    storefront: 'Magazin',
    submissionFailed: 'Trimitere eșuată, vă rugăm să încercați din nou.',
    submit: 'Trimite',
    submitAccountDeleteApply: 'Trimiteți cererea de ștergere a datelor',
    submitDataDeleteApply: 'Trimiteți o cerere de ștergere a datelor',
    submitFeedback: 'Trimite parerea ta',
    submitForReview: 'Trimite spre revizuire',
    submitted: 'Trimis',
    successful: 'Reușit',
    sunday: 'Duminică',
    supportMapDown: {},
    supportedChannel: {},
    sureAgree: 'Sunteți de acord sau nu?',
    sureBackApply: 'Confirmați retragerea cererii de ștergere a contului',
    sureDelete: 'Odată șters, acesta nu poate fi recuperat. Sigur vrei să-l ștergi',
    sureDeleteData: 'Sunteți sigur că doriți să ștergeți datele selectate? Odată confirmate, datele vor fi șterse imediat și nu vor putea fi recuperate',
    sureDeleteSeries: {},
    sureDeleteSetting: {},
    sureDeleteStoreInfo: 'Confirmați ștergerea acestor informații despre magazin? După ștergere, informațiile nu vor mai putea fi recuperate.',
    sureReject: 'Sunteți sigur că doriți să respingeți?',
    sureSuspend: 'Trimiterea se va opri după terminare. Ești sigur că vrei să reziliezi',
    suspend: 'Terminați',
    sv_SE: 'suedez',
    switchLanguage: 'Schimbați limba',
    system: 'Sistem',
    systemBusy: 'Sistemul este ocupat, vă rugăm să încercați din nou mai târziu',
    systemVersion: 'versiunea de sistem',
    tboxInstall: 'Tbox – instalare ulterioară',
    tboxIntro: 'T-Box este dispozitivul cheie pentru realizarea funcției inteligente de conectare la rețea a vehiculelor',
    teamConfigTip: {},
    threeMonths: 'Trei luni',
    thursday: 'Joi',
    time: 'Timp',
    timeSend: 'Trimitere cronometrată',
    timedOffline: 'Programat offline',
    timedPush: 'Push temporizat',
    timedRelease: 'Lansare programată',
    timedSendTime: 'Trimite ora',
    tips: 'Sfaturi',
    title: 'titlu',
    to: 'Către',
    toBeReleased: 'În curând',
    topMenu: 'Meniul de sus',
    topicContent: 'Conținutul subiectului',
    topicList: 'Lista subiectelor',
    topicManagement: 'Managementul temelor',
    topicSearch: 'Căutare subiect',
    topicTitle: 'Titlul subiectului',
    totalAndlLayoutOfStores: 'Numărul total și distribuția magazinelor',
    totalClicks: {},
    totalNumber: 'Număr total de ori',
    tr_TR: 'turc',
    triggerNum: 'Numărul de declanșatoare',
    tuesday: 'Marți',
    turnOn: 'Deschide',
    twoCarAndFourCarOfNumber: 'Numărul de utilizatori de vehicule pe două și patru roți',
    twoCarOfNumber: 'Numărul de utilizatori de vehicule pe două roți',
    twoWheelConfig: {},
    twoWheeler: 'Masina cu doua roti',
    twoWheelerAndFourWheeler: 'Vehicule pe două și patru roți',
    twoWheelerMostClicks: 'Modelele de vehicule pe două roți cu cele mai multe clicuri',
    twoWheelowner: {},
    type: 'Tip',
    typeMessage: 'tip de feedback',
    types: 'Tip',
    unbind: 'Neconectat',
    unbindingCommitment: {},
    unbindingLabelRealName: 'Numele dvs. comple',
    unbound: 'Dezlegat.',
    understandRealtimeConditions: 'Primiți vibrații ale vehiculului și mesaje electronice de memento pentru intrarea și ieșirea din vehicul și înțelegeți starea vehiculului în timp real',
    uninstallTboxDesc: 'Pentru vehiculele care nu au un T-Box instalat, puteți vizualiza informații de bază despre vehicul, cum ar fi numărul cadrului, numărul motorului și manualul electronic după legare.',
    unitCurrencyPer: {},
    unitMonth: 'Luna',
    unlimited: 'Nelimitat',
    unpaid: {},
    unprocessed: 'Nepratată',
    unresolved: 'Încă nu se poate rezolva? Clic',
    unspecified: 'Confidențialitate',
    upToTopics: 'Puteți adăuga până la %s subiecte',
    updateAuthenticationTime: 'Actualizare timp de autentificare',
    updateBy: 'Actualizator',
    updateSuccess: {},
    updateTime: 'Ora de actualizare',
    updating: 'actualizare',
    upgradeAgainDescription: 'Sarcina de actualizare a fost reîmpinsă. Vă rugăm să urmați 【Ghidul】 din partea de sus a paginii curente pentru a conecta rețeaua de afișare tft pentru a face upgrade.',
    upgradeAssistant: 'Ajutor',
    upgradeDescription: 'Când este găsită o nouă versiune, vă rugăm să urmați 【Ghidul】 din partea de sus a paginii curente pentru a conecta rețeaua de afișare tft pentru a face upgrade.',
    upgradeSuccessful: 'Actualizare reușită',
    upgradeType: 'Metoda de actualizare',
    upload: 'Încărcați',
    uploadDisplayPicture: {},
    uploadFail: 'Upload eșuat',
    uploadFailed: 'Încărcarea nu a reușit, vă rugăm să încercați o altă rețea',
    uploadFailedOfTry: 'Încărcarea nu a reușit, încercați din nou',
    uploadFileMore1M: 'Dimensiunea fișierului de încărcare nu depășește 1M',
    uploadFiles: 'Încarcă fișierul',
    uploadImageRules1To1: 'Formatul imaginii trebuie să fie jpg/jpeg/png, cu un raport de imagine de 1:1 și o dimensiune maximă de 5MB',
    uploadLog: 'Încarcă jurnal',
    uploadPicture: 'Încărcare fotografie',
    uploadQuantityExceed: 'Numărul de încărcări depășește limita',
    uploadSuccessful: 'Încărcați cu succes',
    uploadTime: 'Timp de încărcare',
    uploadTip556_740: {},
    uploadVideoRules: 'Este acceptată doar încărcarea unică de fișiere video. Se recomandă ca dimensiunea unui singur videoclip să nu depășească 50 MB.',
    uploadVideoRules4To3: 'Suport format video, raport recomandat de 4:3, dimensiune care nu depășește 50MB',
    urlLink: 'Link URL',
    user: 'Utilizator',
    userAccount: 'Cont de utilizator',
    userEmail: 'E-mail',
    userGender: 'Genul utilizatorului',
    userId: 'ID utilizator',
    userIdTemplate: 'ID-ul utilizatorului Import șablon',
    userIdentity: 'ID utilizator',
    userLocalTime: 'Ora utilizatorului final',
    userLogin: 'Autentificare',
    userMobilePhone: 'numărul de telefon mobil',
    userModel: 'Model de utilizator',
    userName: 'Nume de utilizator',
    userName1: {},
    userNickname: 'Porecla utilizatorului',
    userNum: 'Numărul utilizatorului',
    userPhone: 'Număr de telefon mobil',
    userRealName: 'Numele real al utilizatorului',
    userReply: 'În așteptarea răspunsului utilizatorului',
    userStatus: 'Starea utilizatorului',
    userType: 'Tipul de utilizator',
    userUnbind: 'Deconectarea utilizatorului',
    users: 'utilizatorii',
    vacationTime: 'Timp de vacanță',
    validNumberVolume: 'Numărul de obiective valide',
    validNumerDescription: 'Numărul de dispozitive rămase după filtrarea grupului țintă selectat pentru sarcina push',
    validateAfter24Hours: 'Acceptă doar selecții de timp viitoare în termen de 24 de ore',
    validateEmail: 'Formatul adresei de e-mail este greșit, vă rugăm verificați.',
    validateImageRadio: 'Cerințe privind formatul fișierului imagine:  %s, raportul de aspect al imaginii:  %s, nu mai mult de %s',
    validateImageSize: 'Cerințe privind formatul fișierului imagine:  %s, dimensiunea recomandată a imaginii:  %s, nu mai mult de %s',
    validatePhone: 'Eroare de format a numărului de telefon, vă rugăm să verificați',
    validateVideo: 'Cerințe privind formatul fișierului video:  %s, nu mai mult de %s',
    validateVin: 'VIN greșit, vă rugăm să verificați.',
    validationCodeError: 'Eroare cod de verificare',
    vechicleFirstBindTime: 'Ora reală a primei asocieri a vehiculului',
    vehicleAlarmDetails: 'Detalii alarma vehiculului',
    vehicleBindDuration: 'Durata de legare vehiculului',
    vehicleBrochure: 'Broșura vehiculului',
    vehicleColor: 'Culoarea vehiculului',
    vehicleDetails: 'Detalii despre vehicul',
    vehicleDrivingLicense: 'Certificatul de înmatriculare a vehiculului.',
    vehicleFaultDetails: 'Detalii de avarie a vehiculului',
    vehicleGallery: 'Galeria de vehicule',
    vehicleGalleryEntranceConfiguration:
      'Pagina showroom-ului de motociclete APP și imaginile de la intrarea funcției galeriei vehiculelor sunt toate preluate din următoarea configurație. Vă rugăm să vă asigurați că cele trei imagini sunt completate în configurație.',
    vehicleGalleryEntranceSettings: 'Setări de intrare în galeria vehiculelor',
    vehicleGalleryUploadRules: 'Cerința pentru formatul imaginii este jpg/jpeg/png. Se recomandă ca dimensiunea unei singure imagini să nu depășească 5 MB. Pot fi importate maximum 10 imagini simultan. Sunt permise importuri multiple.',
    vehicleIdHomepageImage: 'Pagina principală a certificatului de înmatriculare a vehiculului cu numele proprietarului și VIN-ul.',
    vehicleModel: 'Model de vehicul',
    vehicleModelAlbum: 'Album model',
    vehicleModelCategorySort: 'Sortați după categoria vehiculului',
    vehicleModelDescription: 'Descrierea modelului',
    vehicleModelList: 'Lista de modele',
    vehicleModelManagement: 'Managementul modelelor de vehicule',
    vehicleModelName: 'Numele modelului',
    vehicleModelQuery: 'Interogare despre modelul vehiculului',
    vehicleModelSeries: 'Seria de modele',
    vehicleModelSorting: 'Sortarea modelelor',
    vehicleModelType: 'Tipul modelului',
    vehicleName: 'Numele vehiculului',
    vehicleNetworkEquipment: 'Dispozitiv de rețea pentru vehicule',
    vehicleOutboundCountry: 'Țara de ieșire a vehiculului',
    vehicleRemark: 'remarci ale vehiculului',
    vehicleShareInstruction: 'Instrucțiuni de partajare a vehiculelor',
    vehicleShareInstructionAdd: 'Instrucțiuni de partajare a vehiculelor noi',
    vehicleShareInstructionEdit: 'Editează instrucțiunile de partajare a vehiculelor',
    vehicleType: 'Motor nr.',
    vehicleTypeSplicing: 'Model de feedback',
    vehicleUnbindingInstructions: 'Instrucțiuni pentru aplicarea pentru deblocarea vehiculului',
    verifyCodeSendFail: 'Trimiterea codului de verificare a eșuat',
    verifyCodeSendSuccess: 'Codul de verificare a fost trimis cu succes',
    versionCode: 'Versiunea numarul',
    versionIntroduction: 'Introducere versiuni',
    versionManage: 'Gestionarea versiunilor',
    versionManageList: 'Lista de gestionare a versiunilor',
    versionMangeTip:
      'Notă: Nu este permisă crearea unei versiuni mai mari decât numărul versiunii postat în prezent pe piața de aplicații! Personalul de operare și întreținere trebuie să aștepte ca cea mai recentă versiune să fie lansată pe Google Play sau App Store și apoi să creeze înregistrări ale versiunii corespunzătoare celui mai recent număr de versiune. Crearea înregistrărilor în avans nu este permisă.',
    versionPattern: 'Numărul versiunii poate fi introdus doar ca număr întreg de la 0 la 999.',
    versionRequired: 'Numărul versiunii nu poate fi gol',
    vhDataBasicService: 'Datele vehiculului Serviciul de bază',
    video: 'Video',
    videoContent: 'Conținut video',
    videoCover: 'Coperta video',
    videoDetail: 'Detalii video',
    videoDisplayImages: 'Afișaj video',
    videoFile: 'Fișier video',
    videoGuide: 'Configurare video boot',
    videoImageValidate: 'Cerințe pentru formatul fișierului imagine: png jpg jpeg, raportul imaginii 16:9, dimensiunea nu mai mare de 5 MB',
    videoList: 'Lista video',
    videoMaxSizeValidate: 'Dimensiunea videoclipului nu poate depăși 150 MB',
    videoSizeExceed: 'Vă rugăm să încărcați un videoclip cu o lățime și înălțime de %s',
    viewAllComment: 'Vedeți toate recenziile',
    viewCount: 'numărul de vizionări',
    viewCurrentLocation: 'Deschideți aplicația pentru a vizualiza locația curentă a vehiculului în orice moment',
    viewCurrentLocation2: 'Deschideți aplicația pentru a vedea locația curentă a vehiculului în orice moment, ceea ce este convenabil pentru a găsi vehicule la distanță apropiată',
    viewDetails: 'Vizualizare detalii',
    viewFeedBackRecords: 'Vizualizați înregistrările de feedback',
    viewLocation: 'Deschideți aplicația pentru a verifica locația vehiculului în orice moment',
    viewModel: {},
    viewPush: 'Vezi Push',
    viewSeries: {},
    viewVehicleInfomation: 'Suport pentru vizualizarea traseului zilnic, kilometrajului, duratei, vitezei și a altor informații ale vehiculului',
    views: 'Vizualizări',
    vin: 'VIN',
    virginia: 'Virginia',
    waitForReview: 'În așteptarea revizuirii',
    waitUploading: 'Încărcare, vă rugăm să așteptați',
    waitingManualReview: 'Se așteaptă revizuirea manuală',
    waitingOnline: {},
    waitingPush: 'Aşteptare',
    wednesday: 'Miercuri',
    whatOTA: 'Ce este OTA?',
    whyUseNavigation: 'Cum să utilizați navigația',
    whyUseSetting: 'Cum să faci setările generale ale aplicației',
    withCountry: 'Țară/Regiune (IP)',
    withInformation: 'Cu informații',
    withTBOX: {},
    withdrawn: 'Revocată',
    withoutCarOfNumber: 'Numărul de utilizatori fără mașină',
    withoutTBOX: {},
    writeAccountToPass: 'Completați informațiile despre contul dvs. și completați verificarea identității',
    year: {},
    yes: 'Da',
    youHaveFeedbackMessage: 'Aveți ** feedback de la utilizatori care nu a fost urmărit în mod eficient, vă rugăm să rezolvați-l la timp',
    youthVehicleOwner: {},
    yoyGrowth: 'Crescut cu  YoY',
    zh_CN: 'chinez',
  },
};
